import moment from 'moment'

/* Clearout CRM — Trial Periods: products, presets + date/status helpers.
   The Trial shape the components consume is the contract the backend response
   is expected to map onto. */

export const PRODUCTS = [
  { key: 'data_pulse', label: 'Data Pulse', icon: 'fa-wave-square', enabled: true },
  { key: 'email_verifier', label: 'Email Verifier', icon: 'fa-envelope-circle-check', enabled: false },
  { key: 'email_finder', label: 'Email Finder', icon: 'fa-magnifying-glass', enabled: false },
  { key: 'prospect', label: 'Prospect', icon: 'fa-users-viewfinder', enabled: false },
]

// Extend / re-enable duration presets requested by the operator team.
export const PRESETS = [
  { key: '1d', label: '1 Day', days: 1 },
  { key: '1w', label: '1 Week', days: 7 },
  { key: '1m', label: '1 Month', days: 30 },
  { key: '1y', label: '1 Year', days: 365 },
]

export const STATUS_META = {
  active: { color: '#198754', label: 'Active' },
  expired: { color: '#a3a3a3', label: 'Expired' },
}

// ---- Date / status helpers --------------------------------------------------
export const iso = (date) => moment(date).format('YYYY-MM-DD')

export const fmtDate = (date) => moment(date).format('D MMM YYYY')

export const addDays = (date, n) => moment(date).add(n, 'days').format('YYYY-MM-DD')

export const daysBetween = (start, end) => moment(end).startOf('day').diff(moment(start).startOf('day'), 'days')

// Whole-day count remaining from today to the end date (can be negative).
export const daysLeft = (endDate) => moment(endDate).startOf('day').diff(moment().startOf('day'), 'days')

// "Expiring soon" matches the backend's ~3-day reminder window. Computed from the end date on
// a calendar-day boundary so it stays consistent with the locally-rendered end date (rather
// than the server's floored days_remaining, which under-counts a partial UTC day).
export const SOON_THRESHOLD_DAYS = 3
export const isExpiringSoon = (trial) => {
  if (trial.status !== 'active') return false
  const dl = daysLeft(trial.endDate)
  return dl >= 0 && dl <= SOON_THRESHOLD_DAYS
}
